/* 兼容没有Promise.prototype.finally方法的浏览器 */
/* eslint-disable */
if (!Promise.prototype.hasOwnProperty('finally')) {
  Promise.prototype.finally = function(callback) {
    let P = this.constructor
    return this.then(
      (value) => P.resolve(callback()).then(() => value),
      (reason) =>
        P.resolve(callback()).then(() => {
          throw reason
        })
    )
  }
}
/* eslint-disable */

